import script from "./esButtonNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./esButtonNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./esButtonNavigation.vue?vue&type=style&index=0&id=17136285&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17136285"]])

export default __exports__